import round from 'lodash/round';
import numberOrdinal from '@sdk/utils/numberOrdinal';
import { MissedBreaks } from '@sdk/automatedBreaks/types/MissedBreaks';
import { AttestationOption } from '@sdk/automatedBreaks/types/Attestation';
import { AutomatedBreaksSettingsUI } from '@sdk/automatedBreaks/types/AutomatedBreaksSettingsUI';
import { v4 } from 'uuid';

import {
  AttestationItemStep,
  Attestation
} from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AttestationView/attestationView.types';

export const getAttestationOptions = (
  attestationItem: Attestation,
  automatedBreaksSettings: AutomatedBreaksSettingsUI,
  isWaivingAllowed: boolean
): { description: string; value: AttestationOption }[] => {
  const { breakType, breakNumber } = attestationItem;
  const { breakDuration, breakThreshold } = automatedBreaksSettings[breakType];

  const attestationWaivedOption = {
    description: `I had the opportunity, but I chose not to take a ${breakType} break.`,
    value: AttestationOption.waived
  };
  const attestationPreventedOption = {
    description: `No, I was prevented from taking a ${breakType} break.`,
    value: AttestationOption.prevented
  };
  const attestationTakenOption = {
    description: `Yes, I took a ${breakDuration}-minute ${breakType} break before the ${numberOrdinal(
      round((breakNumber * breakThreshold) / 60, 2)
    )} hour of work ended.`,
    value: AttestationOption.taken
  };

  if (isWaivingAllowed) {
    return [attestationTakenOption, attestationWaivedOption, attestationPreventedOption];
  }

  return [attestationTakenOption, attestationPreventedOption];
};

export const getAttestationsItems = (missedBreaks: MissedBreaks) => {
  if (!missedBreaks) {
    return [];
  }

  return Object.entries(missedBreaks).reduce((acc, breaks): Attestation[] => {
    const [automatedType, breakNumbers] = breaks;
    const missedBreaksArray = breakNumbers.map(breakNumber => ({
      id: v4(),
      breakType: automatedType,
      breakNumber,
      option: null,
      text: null,
      step: AttestationItemStep.first
    }));

    return [...acc, ...missedBreaksArray];
  }, []);
};

export const getHeaderText = (attestationItem: Attestation, attestationsCount: number) => {
  if (attestationsCount > 1) {
    return `Did you take your ${numberOrdinal(attestationItem.breakNumber)} company ordered ${
      attestationItem.breakType
    } break?`;
  }

  return `Did you take your company ordered ${attestationItem.breakType} break?`;
};
